import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { getCronTriggerPath } from '~entities/stripe/lib/cron-api-path';
import { baseAPI } from '~shared/api/base-api';

interface TriggerExpiredEventsParams {
  isV2: boolean;
}

export const triggerExpiredEvents = async (
  params: TriggerExpiredEventsParams,
) => {
  const response = await baseAPI.post<{ ok?: true; processedCount?: number }>(
    getCronTriggerPath('expired-events', params.isV2),
  );
  return response.data;
};

export const useTriggerExpiredEvents = () => {
  return useMutation({
    mutationFn: triggerExpiredEvents,
    onSuccess: (data) => {
      const count = data?.processedCount;
      toast.success(
        typeof count === 'number'
          ? `Expired events cron triggered (${count} enrollment(s) processed)`
          : 'Expired events cron triggered successfully',
      );
    },
    onError: (error: unknown) => {
      const errorMessage =
        error &&
        typeof error === 'object' &&
        'response' in error &&
        error.response &&
        typeof error.response === 'object' &&
        'data' in error.response &&
        error.response.data &&
        typeof error.response.data === 'object' &&
        'message' in error.response.data &&
        typeof error.response.data.message === 'string'
          ? error.response.data.message
          : 'Failed to trigger expired events cron.';

      toast.error(errorMessage);
    },
  });
};
